import { Image } from "./types";

export const resToImage = (res: any): Image => {
  return {
    id: res.id,
    originalName: res.originalName ?? "",
    generatedName: res.generatedName ?? "",
    contentType: res.contentType ?? "",
    url: `${process.env.REACT_APP_API_URL}/api/v1/images/${res.id}`,
    buffer: new ArrayBuffer(0),
  };
};

export const imageToFormData = (image: Image): FormData => {
  const formData = new FormData();
  formData.append(
    "file",
    new File([image.buffer], image.originalName, { type: image.contentType })
  );
  return formData;
};

export const fileToFormData = async (file: File): Promise<FormData> => {
  const image: Image = {
    id: -1,
    originalName: file.name,
    generatedName: "",
    contentType: file.type,
    url: URL.createObjectURL(file),
    buffer: await file.arrayBuffer(),
  };
  return imageToFormData(image);
};
